import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'

import { PAGINATION } from '../../common/constants'
import { apolloService } from '../../common/services'

import { CREATE_DICTIONARY_WORDS_FOR_TYPE_MUTATION } from '../graphql/mutations'
import { CREATE_DICTIONARY_WORDS_FOR_TYPE } from '../redux/action-types'

const useCreateDictionaryWordsForTypeMutation = (type, refetchLastEvent) => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store =>
    get(store.dictionaryWords.data, type.fieldName, {}),
  )

  const mutate = useCallback(
    async (data, pageSize) => {
      await apolloService.mutate(
        CREATE_DICTIONARY_WORDS_FOR_TYPE_MUTATION,
        {
          data,
          type: type.value,
          pageSize: pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
        },
        dispatch,
        CREATE_DICTIONARY_WORDS_FOR_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, type, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useCreateDictionaryWordsForTypeMutation
